export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '管理员管理';
